/** عرض لابتوب + لقطة موقع عقاري */
export default function ProblemSolutionVisual() {
  return (
    <div className="relative w-full aspect-[4/3] min-h-[260px] md:min-h-[320px]">
      <div className="relative w-full h-full rounded-2xl overflow-hidden bg-gradient-to-br from-slate-900 via-[#0c1222] to-teal-950 border border-white/5 p-5 md:p-8 flex items-center justify-center">
        <div className="relative w-full max-w-md">
          <div className="rounded-xl border border-white/15 bg-slate-800/90 p-2 shadow-[0_20px_60px_-15px_rgba(20,184,166,0.35)]">
            <div className="rounded-lg overflow-hidden bg-[#030712] border border-teal-400/10">
              <div className="flex items-center gap-1.5 px-3 py-2 border-b border-white/10 bg-black/60">
                <span className="w-2 h-2 rounded-full bg-red-400/90" />
                <span className="w-2 h-2 rounded-full bg-amber-400/90" />
                <span className="w-2 h-2 rounded-full bg-emerald-400/90" />
                <div className="flex-1 h-4 mx-1 rounded bg-white/5" />
              </div>
              <img
                src="/images/real-estate-hero.png"
                alt="نموذج موقع عقاري — واجهة احترافية"
                className="block w-full h-auto"
                width={1024}
                height={470}
                loading="lazy"
              />
            </div>
          </div>
          <div className="h-2.5 w-full rounded-b-lg bg-gradient-to-b from-slate-600 to-slate-800 border-x border-b border-white/10" />
          <div className="h-1 w-14 mx-auto mt-1 rounded-full bg-slate-600/60" />
        </div>

        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 w-56 h-14 bg-teal-400/20 blur-2xl pointer-events-none" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#030712]/70 via-transparent to-teal-500/5 pointer-events-none" />
      </div>
    </div>
  );
}
